import './App.css';
import { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { firebaseDB } from './firebase-config';
import { collection, getDocs } from 'firebase/firestore';
import axios from 'axios';
import { AuthProvider, AdviceContext, WeatherStartContext, WeatherFutureContext } from './contexts';
import { WeatherFuture, Header, Home, PollutionAir, LoginOn, SignOn, UserDashboard } from './modules';
import { ErrorBoundary } from './modules/components/error-boundary';
import { Reloads } from './reload';
import { CITY_DEFAULT } from './consts/default';
import { URL_WEATHER, URL_WEATHER_LOCATION, URL_FIVE_DAYS, LOCATION_JSON, URL_GET_UANAME } from './consts/url-api';

function App() {
  const [advices, setAdvices] = useState([]);
  const [coord, setCoord] = useState('');
  const [cityValue, setCityValue] = useState('');
  const [state, setState] = useState([]);
  const [future, setFuture] = useState([]);
  const [errors, setErrors] = useState('');
  const [getUANameCity, setUANAmeCity] = useState('');

  const advicesCollectionRef = collection(firebaseDB, 'advices');
  const getCity = (e) => setCityValue(e.target.value);
  window.onunload = () => { sessionStorage.setItem('cityName', state.name) }
  const getCityStore = sessionStorage.getItem('cityName');
  const city = cityValue ? cityValue : CITY_DEFAULT;
  Reloads();

  useEffect(() => {
    const getAdvices = async () => {
      const data = await getDocs(advicesCollectionRef);
      setAdvices(data.docs.map(doc => ({ ...doc.data(), id: doc.id })))
    };
    getAdvices();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    axios.get(LOCATION_JSON)
      .then(res => setCoord([res.data.latitude, res.data.longitude]))
      .catch(error => console.log(error))
  }, []);

  useEffect(() => {
    axios.get(
      !coord ? URL_WEATHER(city) :
        cityValue ? URL_WEATHER(city) :
          getCityStore ? URL_WEATHER(getCityStore) : URL_WEATHER_LOCATION(coord[0], coord[1])
    )
      .then(res => {
        setState(
          {
            name: res.data.name,
            id: res.data.id,
            date: res.data.dt,
            lat: res.data.coord.lat,
            lon: res.data.coord.lon,
            temper: res.data.main.temp,
            feel: res.data.main.feels_like,
            grnd: res.data.main.grnd_level,
            pressure: res.data.main.pressure,
            humidity: res.data.main.humidity,
            sunrise: res.data.sys.sunrise,
            sunset: res.data.sys.sunset,
            clouds: res.data.clouds.all,
            description: res.data.weather[0].description,
            icon: res.data.weather[0].icon,
            alt: res.data.weather[0].main,
            deg: res.data.wind.deg,
            gust: res.data.wind.gust,
            speed: res.data.wind.speed,
            visibility: res.data.visibility
          }
        );
        setErrors('');
      })
      .catch(error => {
        console.error(error.message, error.response.status);
        setErrors(error);
      })
    // eslint-disable-next-line
  }, [URL_WEATHER_LOCATION(coord[0], coord[1]), URL_WEATHER(city)]);

  useEffect(() => {
    state.name && axios.get(URL_GET_UANAME(state.name))
      .then(res => setUANAmeCity(res.data[0].local_names.uk))
      .catch(error => console.error(error.message, error.response.status))
  }, [state.name]);

  useEffect(() => {
    state.name && axios.get(URL_FIVE_DAYS(state.name))
      .then(res => setFuture(res.data.list))
      .catch(error => console.error(error))
    // eslint-disable-next-line
  }, [URL_FIVE_DAYS(state.name)]);

  return (
    <AdviceContext.Provider value={advices}>
      <WeatherStartContext.Provider value={state}>
        <WeatherFutureContext.Provider value={future}>
          <AuthProvider>
            <Routes>
              <Route path='/' element={<Header />}>
                <Route index element={
                  <ErrorBoundary>
                    <Home
                      city={city}
                      temperature={state.temper}
                      cityValue={cityValue}
                      getCiti={getCity}
                      errors={errors}
                      cityName={getUANameCity}
                      lat={state.lat}
                      lon={state.lon}
                    />
                  </ErrorBoundary>
                } />
                <Route path=':city' element={<WeatherFuture cityName={getUANameCity} />} />
                <Route path='pollution-air' element={
                  <PollutionAir city={getUANameCity} lat={state.lat} lon={state.lon} />
                } />
                <Route path='login' element={<LoginOn />} />
                <Route path='sign' element={<SignOn />} />
                <Route path='children' element={<UserDashboard />} />
              </Route>
            </Routes>
          </AuthProvider>
        </WeatherFutureContext.Provider>
      </WeatherStartContext.Provider>
    </AdviceContext.Provider>
  );
}

export default App;
